import type { MailFolder } from '@sunucupark/shared';
import { qk, useApi, useSession } from '@sunucupark/client-react';
import { useQuery, type UseQueryResult } from '@tanstack/react-query';
import { fetchMailFolders } from '@/shared/mail-folders';

/**
 * The mailbox folders with their unread counts. The feature asks for data
 * through hooks; it never builds a client or touches the browser (ADR 0006).
 */
export function useFolders(): UseQueryResult<MailFolder[]> {
  const api = useApi();
  const session = useSession();
  const accountId = session?.accountId ?? '';
  return useQuery({
    queryKey: qk.folders(accountId),
    enabled: accountId.length > 0,
    queryFn: ({ signal }) => fetchMailFolders(api, signal),
  });
}
